import _slicedToArray from "/builds/telavita-core/frontend/core-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _defineProperty from "/builds/telavita-core/frontend/core-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import React, { useState, useEffect, createRef } from 'react';
import clsx from 'clsx';
import { useStyles } from './styles';
import { useTheme } from 'react-jss';
export var Tab = function Tab(_ref) {
  var _clsx;

  var label = _ref.label,
      active = _ref.active,
      onClick = _ref.onClick,
      customClassName = _ref.customClassName;
  var theme = useTheme();
  var styles = useStyles({
    theme: theme
  });
  var containerStyle = clsx((_clsx = {}, _defineProperty(_clsx, styles.tab, true), _defineProperty(_clsx, styles.activeTab, active), _defineProperty(_clsx, customClassName, !!customClassName), _clsx));
  return React.createElement("button", {
    role: 'tab',
    className: containerStyle,
    onClick: onClick
  }, label);
};
export var Tabs = function Tabs(_ref2) {
  var selectedTab = _ref2.selectedTab,
      onChange = _ref2.onChange,
      children = _ref2.children,
      _ref2$showBorder = _ref2.showBorder,
      showBorder = _ref2$showBorder === void 0 ? false : _ref2$showBorder;
  var theme = useTheme();
  var styles = useStyles({
    theme: theme
  });
  var arrLength = children.length;

  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      tabWidth = _useState2[0],
      setTabWidth = _useState2[1];

  var _useState3 = useState([]),
      _useState4 = _slicedToArray(_useState3, 2),
      tabsRef = _useState4[0],
      setTabsRef = _useState4[1];

  useEffect(function () {
    setTabsRef(function (elRefs) {
      return Array(arrLength).fill(null).map(function (_, i) {
        return elRefs[i] || createRef();
      });
    });
  }, [arrLength]);
  useEffect(function () {
    if (tabsRef.length > 0) setTabWidth(tabsRef[selectedTab].current.getBoundingClientRect().width);
  }, [selectedTab, tabsRef]);
  var slideTranslateX = tabsRef.reduce(function (acc, curr, index) {
    if (index < selectedTab && curr.current) {
      acc += selectedTab > 0 ? curr.current.getBoundingClientRect().width + 20 : curr.current.getBoundingClientRect().width;
    }

    return acc;
  }, 0);
  var tabs = children.map(function (child, index) {
    var handleClick = function handleClick(e) {
      onChange(e, child.props.id);
    };

    return React.createElement("div", {
      ref: tabsRef[index],
      style: {
        marginRight: 20
      },
      key: child.props.id + index
    }, React.cloneElement(child, {
      key: child.props.id,
      active: child.props.id === selectedTab,
      onClick: handleClick
    }));
  });
  return React.createElement("div", {
    className: styles.tabsHeaderContainer
  }, React.createElement("div", {
    className: styles.tabsHolder
  }, tabs), React.createElement("div", {
    className: showBorder && styles.tabsSliderWrapper
  }, React.createElement("div", {
    className: styles.tabsSlider,
    style: {
      width: tabWidth,
      transform: "translateX(".concat(slideTranslateX, "px)")
    }
  })));
};
export var TabPanel = function TabPanel(_ref3) {
  var _clsx2;

  var children = _ref3.children,
      isActive = _ref3.isActive,
      customClassName = _ref3.customClassName;
  var theme = useTheme();
  var styles = useStyles({
    theme: theme
  });
  var containerStyle = clsx((_clsx2 = {}, _defineProperty(_clsx2, styles.tabPanel, true), _defineProperty(_clsx2, styles.tabPanelActive, isActive), _defineProperty(_clsx2, styles.tabPanelHidden, !isActive), _defineProperty(_clsx2, customClassName, !!customClassName), _clsx2));
  return React.createElement("div", {
    className: containerStyle
  }, children);
};